package org.matthewo.pages.admin

import org.matthewo.router.TSRouteBuilder
import org.matthewo.router.div
import tanstack.router.core.RoutePath

val ADMIN_PATH = RoutePath("admin")
val USERS_TABLE_PATH = RoutePath(ADMIN_PATH / "users")

fun TSRouteBuilder.adminRoutes() {
    TSRoute(USERS_TABLE_PATH, UsersTable)
}
